<template>
  <label
    :for="label"
    class="custom-input"
    tabindex="-1"
    ref="label"
    :class="{ 'have-drop': marketList.length }"
  >
    <input
      :id="label"
      type="text"
      @input="handleInput"
      :value="value"
      :readonly="marketList.length > 0"
      ref="input"
      placeholder=" "
    />
    <span :style="{ color: fontcolor }" class="label">{{ label }}</span>
    <div
      class="drop-list"
      :class="{ boxBorder: boxBorder }"
      v-if="marketList.length"
    >
      <perfect-scrollbar>
        <ul>
          <li
            v-for="(market, index) in marketList"
            :key="index"
            @click.prevent.stop="select(market[option])"
          >
            {{ market[labelOption || option] }}
          </li>
        </ul>
      </perfect-scrollbar>
    </div>
  </label>
</template>

<script>
export default {
  name: "customInput",
  props: {
    marketList: { default: "" },
    option: { default: "cardNumber" },
    labelOption: { default: "" },
    label: { default: "" },
    textAlign: { default: "left" },
    theme: { default: "light" },
    color: { default: "var(--box-color)" },
    fontcolor: { default: "var(--fontcolor)" },
    boxBorder: { default: false },
    value: String,
  },
  data() {
    return {
      drop: false,
    };
  },
  computed: {
    input() {
      return this.$refs.input;
    },
  },
  methods: {
    select(e) {
      this.$refs.input.value = e;
      this.$emit("input", this.$refs.input);
      this.$refs.label.blur();
    },
    handleInput() {
      this.$emit("input", this.$refs.input);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-input {
  margin: 10px 0;
  position: relative;
  height: 40px;
  display: block;

  input {
    width: 100%;
    height: 100%;
    padding: 0 10px;
    border-radius: 5px;
    background-color: var(--light-grey) !important;
  }

  .label {
    position: absolute;
    margin: 0;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    padding: 0 10px;
    transition: 0.3s;
    border-radius: 5px;
    min-width: max-content;
  }

  .drop-list {
    position: absolute;
    top: calc(100% + 5px);
    width: 100%;
    height: auto;
    /*max-height: 100px;*/
    background-color: var(--light-grey);
    border: 1px solid var(--primary-color);
    border-radius: 5px;
    z-index: 10;
    display: none;
    visibility: hidden;

    /*@media (max-width: 768px){
                position: fixed;
                top: 50%;
                right: 50%;
                transform: translate(50%,-50%);
                width: calc(100vw - 40px);
            }*/

    &.boxBorder {
      border: 1px solid var(--yellow);
    }

    .ps {
      height: 100%;
      max-height: 100px;
      /*@media (max-width: 768px){
                    max-height: calc(100vh - 60px);
                }*/
    }

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      width: 100%;
      color: var(--dark);

      li {
        padding: 3px 5px;
        width: 100%;
        border-radius: 5px;
        font-size: 14px;

        &:hover {
          background-color: var(--yellow-hover);
        }
      }
    }
  }

  &.have-drop {
    background-image: url("../../../assets/icons/arrow_drop_bottom-dark.svg");
    background-repeat: no-repeat;
    background-size: 12px;
    background-position: right 10px center;
  }

  &:focus-within {
    color: var(--yellow);
    border-color: var(--yellow);

    input {
      color: var(--yellow);
    }

    &.have-drop {
      background-image: url("../../../assets/icons/arrow_drop_bottom-yellow.svg");
    }

    .label {
      top: 0;
      font-size: 11px;
    }

    .drop-list {
      display: block;
      visibility: visible;
    }
  }

  input {
    &:focus,
    &.focus {
      border-color: var(--yellow);
      color: var(--yellow);

      ~ {
        .drop-list {
          display: block;
          visibility: visible;
        }

        .label {
          top: 0;
          font-size: 11px;
        }
      }
    }
    &:not(:placeholder-shown) {
      ~ {
        .label {
          top: 0;
          font-size: 11px;
        }
      }
    }
  }
}
</style>
